export enum UserActivityStatusCodes {
  Blocked = 'BLC',
  NotValidated = 'NVA',
  AwaitingApproval = 'AWA',
  Enrolled = 'ENR',
  Active = 'ACT',
  Inactive = 'INA',
  Dormant = 'DRM',
}
